import React from 'react'
import PropTypes from 'prop-types'
import styled, {css} from 'styled-components'
import {ListItemText as RmwcListItemText} from '@rmwc/list'
import '@rmwc/list/styles'

const theme = ({theme}) => css`
  .mdc-theme--on-${theme} &&& {
    color: var(--mdc-theme-neutral3);
  }
`

const StyledRmwcListItemText = styled(RmwcListItemText)`
  ${theme({theme: 'primary'})};
`

const ListItemText = ({children, ...otherProps}) => <StyledRmwcListItemText {...otherProps}>{children}</StyledRmwcListItemText>

ListItemText.propTypes = {
  children: PropTypes.any
}

export {ListItemText}
